/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_BackInputs */

const cs_pm_back = /** @type {(inputs: Pm_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpět`)
};

const en_pm_back = /** @type {(inputs: Pm_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back`)
};

/**
* | output |
* | --- |
* | "Back" |
*
* @param {Pm_BackInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_back = /** @type {((inputs?: Pm_BackInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_BackInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_back(inputs)
	return cs_pm_back(inputs)
});